// Copyright (c) Move Closer 2022.

import { WindowService } from '@movecloser/front-core'

import { AsyncDataContext } from '@contract/async-data'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
function clientSideWebPiDetected (): string {
  const canvas = document.createElement('canvas')

  if (!(canvas.getContext && canvas.getContext('2d'))) {
    return ''
  }

  return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0 ? 'image/webp' : ''
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function detectSupportedFormats (context: AsyncDataContext): string {
  const desireFormats: string[] = ['image/webp']
  const supportedFormats: string[] = []

  if (context.ssr || !WindowService.isDefined) {
    const acceptHeader = context.ssr?.req.headers.accept ?? ''

    for (const f of desireFormats) {
      if (!acceptHeader.includes(f)) {
        continue
      }

      supportedFormats.push(f)
    }
  } else {
    supportedFormats.push(
      clientSideWebPiDetected()
    )
  }

  return supportedFormats.filter(f => f !== null && f !== 'null').join(';')
}
